import { Code, Home, Trophy, Tv } from "lucide-vue-next";
import { defineStore } from "pinia";
import { type Component, computed, markRaw, ref } from "vue";
import { useRoute } from "vue-router/auto";

export interface MenuItem {
	icon: Component;
	tooltip: string;
	path: string;
	hide_mobile?: boolean;
	admin?: boolean;
}

const MENU_ITEMS: MenuItem[] = [
	{ icon: markRaw(Home), tooltip: "Home", path: "/" },
    { icon: markRaw(Tv), tooltip: "History", path: "/replay" },
	{ icon: markRaw(Trophy), tooltip: "Leaderboard", path: "/leaderboard" },
	{ icon: markRaw(Code), tooltip: "Debug", path: "/debug", hide_mobile: true, admin: true }
];

export const useMenuStore = defineStore("menu", () => {
	const route = useRoute();

	const menuItems = ref(MENU_ITEMS);
	const hovered = ref(false);
	const selectedPath = computed(() => {
		return MENU_ITEMS.find((item) => {
			if (item.path === "/") return route.path === "/";
			const path = "/" + item.path.slice(1).split("/").at(0);
			return route.path.startsWith(path);
		})?.path;
	});
	const opened = ref(false);

	return {
		menuItems,
		hovered,
		selectedPath,
		opened
	};
});
